/*
 * scroll-lock.js
 * ──────────────
 * Shared scroll-lock utility for custom modals that do not extend
 * Horizon's DialogComponent (which has its own built-in scroll-lock).
 *
 * Uses the iOS-safe technique: body.position: fixed + body.top = -scrollY,
 * restored via window.scrollTo on unlock. This avoids the jump-to-top
 * bug that affects overflow: hidden on iOS Safari.
 *
 * Exposes window.scrollLock.lock() and window.scrollLock.unlock().
 *
 * Double-lock safe: calling lock() twice does not lose the original
 * scroll position. Orphan-safe: if a modal is destroyed without calling
 * unlock(), the next lock/unlock cycle still works correctly.
 */
(function () {
  'use strict';

  var LOCKED_ATTR = 'data-scroll-locked';

  function lockScroll() {
    var body = document.body;
    // Double-lock prevention: if already locked, keep the original scrollY
    if (body.hasAttribute(LOCKED_ATTR)) return;
    // Interop guard: if Horizon's DialogComponent (or any other lock) has
    // already set body.position = 'fixed', don't overwrite its state.
    // That other lock owns the scroll-restore; we stay out of the way.
    if (body.style.position === 'fixed') return;

    var scrollY = window.scrollY;
    body.setAttribute(LOCKED_ATTR, String(scrollY));
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  }

  function unlockScroll() {
    var body = document.body;
    if (!body.hasAttribute(LOCKED_ATTR)) return;

    var scrollY = parseInt(body.getAttribute(LOCKED_ATTR), 10);
    if (isNaN(scrollY)) scrollY = 0;

    body.removeAttribute(LOCKED_ATTR);
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  window.scrollLock = { lock: lockScroll, unlock: unlockScroll };
})();
